/**
 * Jengo App — PWA Service Worker Registration
 * Only registers in production builds.
 * In development the SW is intentionally skipped to prevent reload loops.
 */

export function registerSW() {
  // Never register in development — causes constant reload loops
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Registered');

        // Notify user when a new version is available
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker?.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              if (window.__jengoToast) {
                window.__jengoToast(
                  'A new version of Jengo is available. Refresh to update.',
                  { duration: 8000 }
                );
              }
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });
}

export function unregisterSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(reg => reg.unregister());
  }
}
